import React from "react";

export const ProfileDropdownIcon = () => {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.59596 10.1171C9.54055 10.1091 9.4693 10.1091 9.40596 10.1171C8.01263 10.0696 6.9043 8.92956 6.9043 7.52831C6.9043 6.09539 8.06013 4.93164 9.50096 4.93164C10.9339 4.93164 12.0976 6.09539 12.0976 7.52831C12.0897 8.92956 10.9893 10.0696 9.59596 10.1171Z"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.8357 15.3419C13.4266 16.6323 11.5582 17.416 9.4999 17.416C7.44156 17.416 5.57323 16.6323 4.16406 15.3419C4.24323 14.5977 4.71823 13.8694 5.56531 13.2994C7.73448 11.8585 11.2811 11.8585 13.4345 13.2994C14.2816 13.8694 14.7566 14.5977 14.8357 15.3419Z"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.50065 17.4173C13.8729 17.4173 17.4173 13.8729 17.4173 9.50065C17.4173 5.1284 13.8729 1.58398 9.50065 1.58398C5.1284 1.58398 1.58398 5.1284 1.58398 9.50065C1.58398 13.8729 5.1284 17.4173 9.50065 17.4173Z"
          stroke="#231F20"
          style={{
            stroke: "#231F20",
            stroke: "color(display-p3 0.1373 0.1216 0.1255)",
            strokeOpacity: 1,
          }}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
